import styled from 'styled-components';
import { Checkbox } from 'antd';
import React from 'react';

import { colors } from 'helpers/ColorHelper';

const StyledContainer = styled.div`
  height: 35px;
`;

const StyledCheckbox = styled(Checkbox)`
  display: flex;
  align-items: flex-start;
`;

const StyledLabel = styled.div`
  padding-left: 10px;
  margin: 0;
`;

const CheckboxNormal = ({
  accentColor = colors.ULTRAMARINE_BLUE,
  value,
  checked,
  name,
  children,
  onChange,
  disabled,
  style,
  ...rest
}) => {
  return (
    <StyledContainer style={style}>
      <StyledCheckbox
        name={name}
        value={value}
        checked={checked}
        onChange={onChange}
        disabled={disabled}
      >
        <StyledLabel {...rest}>{children}</StyledLabel>
      </StyledCheckbox>
    </StyledContainer>
  );
};

export default CheckboxNormal;
